import { Component, OnInit } from '@angular/core';
import { CtxForm } from '../../../_forms/models/form.model';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { AuthnService } from '../../../_services/authn.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CtxButtonComponent } from '../../button/button.component';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CtxAlertComponent } from '../../alert/alert.component';

@Component({
  selector: 'ctx-customer-reset-password',
  templateUrl: './customer-reset-password.component.html',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CtxAlertComponent,
    MatFormFieldModule,
    MatInputModule,
    CtxButtonComponent,
  ],
})
export class CustomerResetPasswordComponent extends CtxForm implements OnInit {
  form: FormGroup;
  token: string;
  userId: string;
  constructor(
    private fb: FormBuilder,
    private authnService: AuthnService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    super();
  }

  ngOnInit(): void {
    this.formGroup = this.fb.group({
      newPassword: ['', Validators.minLength(8)],
    });

    this.token = this.route.snapshot.queryParams['token'];
    if (this.token) {
      this.token = encodeURIComponent(this.token);
    }
    this.userId = this.route.snapshot.queryParams['userId'];
    if (this.userId) {
      this.userId = decodeURIComponent(this.userId);
    }
  }
  async reset(): Promise<void> {
    if (!this.formGroup.valid) {
      return;
    }
    try {
      this.resetApiMessage();
      this.setState('submit', true);
      this.setState('disabled', true);
      await this.authnService.resetPassword(
        this.token,
        this.userId,
        this.formGroup.value.newPassword
      );
      this.setCustomApiMessage({
        text: `Password has been reset.`,
        alertLevel: 'success',
      });
      setTimeout(async () => {
        await this.router.navigate(['auth/login']);
      }, 2000);
    } catch (errorResponse) {
      this.setApiMessage(errorResponse);
    }
    this.setState('submit', false);
    this.setState('disabled', false);
  }
}
